module.exports = __webpack_public_path__ + "d8034ce3eec9d587a651384432886c1c.svg";